import { useState, type FormEvent } from 'react'
import { api, ApiError } from '../../lib/api'
import { Link, useRouter } from '../../lib/router'
import { Button, Notice, TextField } from '../../ui'
import { AuthLayout } from './AuthLayout'

export default function Reset() {
  const { loc, navigate } = useRouter()
  const token = loc.search.get('token') ?? ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    if (password !== confirm) return setError('The two passwords don’t match.')
    setBusy(true)
    try {
      await api.post('/api/auth/reset', { token, password })
      navigate('/login?reset=1', { replace: true })
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong. Please try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Choose a new password">
      <h2>Choose a new password</h2>
      {!token ? (
        <Notice tone="bad">
          This link is incomplete. Please use the link in your email, or <Link to="/forgot">ask for a new one</Link>.
        </Notice>
      ) : (
        <form onSubmit={submit} noValidate>
          <p className="lead">At least 10 characters. Three random words make a strong password that’s easy to remember.</p>
          {error && <Notice tone="bad">{error}</Notice>}
          <TextField label="New password" type="password" autoComplete="new-password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} />
          <TextField label="Type it again" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <Button type="submit" variant="primary" size="lg" block busy={busy}>
            Save password
          </Button>
        </form>
      )}
    </AuthLayout>
  )
}
